import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { KeyWord } from 'src/app/shared/classes/constants';
import { ThemingService } from 'src/app/shared/services/theming.service';
import { ListClass } from '../../shared/classes/list';

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.scss']
})
export class ListComponent implements OnInit {

  editListName = new FormControl('');
  createListName = new FormControl('');
  listNames: ListClass[] = [];
  paginateData: ListClass[] = [];
  indexNumber: any = 0;
  page: number = 1;
  count: number = 4;
  tableSize: number = 15;
  searchText: string = "";
  totalData: string = "0";

  theme: boolean = true;
  constructor(
    private modal: NgbModal,
    private router: Router,
    private themingService: ThemingService
  ) {
    this.themingService.nameKeeper.subscribe(val => this.theme = val)
  }

  ngOnInit(): void {
    let name = KeyWord.nameData;
    for (let i = 0; i < 20; i++) {
      let data = {
        "name": name[Math.floor(Math.random() * name.length)],
        "numberOfItem": Math.floor(Math.random() * 101),
        "notCompletedKeyword": Math.floor(Math.random() * 101),
        "completedKeyWord": Math.floor(Math.random() * 101)
      }
      this.listNames.push(data)
    }
    this.onTableDataChange();
  }

  openModal(content: any, name?: string, index?: number) {
    this.indexNumber = index;
    this.editListName.patchValue(name);
    this.modal.open(content, { centered: true, windowClass: !this.theme ? 'dark-modal' : '' });
  }

  onDelete() {
    this.modal.dismissAll();
    this.listNames.splice(this.indexNumber, 1);
    this.onTableDataChange();
  }

  editNames() {
    this.modal.dismissAll();
    this.listNames.forEach((e, index) => {
      if (index === this.indexNumber) {
        e.name = this.editListName.value
      }
    })
  }

  create() {
    this.modal.dismissAll();
    let obj = {
      "name": this.createListName.value,
      "numberOfItem": Math.floor(Math.random() * 101),
      "notCompletedKeyword": Math.floor(Math.random() * 101),
      "completedKeyWord": Math.floor(Math.random() * 101)
    }
    this.listNames.unshift(obj);
    this.onTableDataChange();
    this.createListName.setValue("")
  }

  openKeywordDetails() {
    this.router.navigate(['/lckr/list-keyword-details']);
  }

  onTableDataChange(event?: any) {
    // this.page = event;
    const lastIndex = this.page * 15;
    const firstIndex = lastIndex + 1 - 15
    const pageCount = this.listNames.length / this.tableSize;
    this.count = Math.ceil(pageCount);
    if (this.page == this.count) {
      this.totalData = firstIndex + "-" + this.listNames.length
    } else {
      this.totalData = firstIndex + "-" + lastIndex
    }

    this.paginateData = this.listNames
      .slice((this.page - 1) * this.tableSize, (this.page - 1) * this.tableSize + this.tableSize);
  }

}
